import * as React from "react";
import type { SVGProps } from "react";
const SvgIcUpload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 17 17"
    {...props}
  >
    <path
      stroke="#040747"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12.027 3.043c1.581.248 2.546 1.522 2.546 3.242v5.205c0 1.93-1.2 3.293-3.123 3.293H5.945c-1.923 0-3.117-1.363-3.117-3.293V6.285c0-1.726.965-3 2.546-3.242"
    />
    <path
      stroke="#040747"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m6.871 4.514 1.831-1.772 1.83 1.772M8.7 2.745v4.824M14.569 9.638h-2.796c-.579 0-1.107.329-1.364.85a1.907 1.907 0 0 1-3.418 0 1.52 1.52 0 0 0-1.365-.85H2.833"
    />
  </svg>
);
export default SvgIcUpload;
